module.exports = __webpack_public_path__ + "static/media/six.d19ba4da.svg";